module.exports = __webpack_public_path__ + "static/media/grid-loading-dark-gray.1b03fd2a.svg";